import { Navigate, Outlet } from 'react-router-dom';
import { useSubscription } from '../hooks/useSubscription';

export const SubscriptionRoute = () => {
  const { isLoading, isActive, error } = useSubscription();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (error) {
    return <Navigate to="/unauthorized" />;
  }

  return isActive ? <Outlet /> : <Navigate to="/no-subscription" />;
};